module.exports = __webpack_public_path__ + "img/Send.ea378e98.svg";